import React, { useEffect, useRef, useState } from "react";
import If from "../../../../../vendors/components/If";
import CienciaEventoController from "../controller/ciencia-evento.controller";
import { Checkbox } from "primereact/checkbox";
import classNames from "classnames";
import ReCAPTCHA from "react-google-recaptcha";
import Environment from "../../../../../environments/environment";

interface Props {
  selectedOption: any;
  setSelectedOption: any;
  cienciaEventoOutros: any;
  setCienciaEventoOutros: any;
  checked: any;
  setChecked: any;
  send: any;
  captchaRef: any;
}

export default function CienciaEvento({
  cienciaEventoOutros,
  setCienciaEventoOutros,
  selectedOption,
  setSelectedOption,
  checked,
  setChecked,
  send,
  captchaRef,
}: Props) {
  const controller = new CienciaEventoController();
  const [showCaptcha, setShowCaptcha] = useState(true);
  const [showOutrosInput, setShowOutrosInput] = useState(false);

  useEffect(() => {
    controller.init();
    setShowCaptcha(Environment.getShowCaptcha());
    setShowOutrosInput(false);
  }, []);

  const handleTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCienciaEventoOutros(event.target.value);
  };

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedOption(event.target.value);
    setShowOutrosInput(event.target.value === "-1");
    if (event.target.value !== "-1") {
      setCienciaEventoOutros("");
    }
  };

  const firstColumn = controller.lista.slice(0, 6);
  const secondColumn = controller.lista.slice(6);

  return (
    <div className="mce-content">
      <div className="mce-section">
        <div className="mce-section__question">
          <span className="mce-section__question-text">
            Como tomou conhecimento do evento?
          </span>
        </div>

        <div className="mce-grid">
          <div className="mce-column">
            {firstColumn.map((m: any) => (
              <label
                key={m.cdSeqCienciaEvento}
                className={classNames("mce-radio", {
                  "mce-radio--selected":
                    selectedOption === m.cdSeqCienciaEvento.toString(),
                  "mce-radio--error": send && !selectedOption,
                })}
              >
                <input
                  type="radio"
                  name="cienciaEvento"
                  value={m.cdSeqCienciaEvento.toString()}
                  checked={selectedOption === m.cdSeqCienciaEvento.toString()}
                  onChange={handleRadioChange}
                />
                <span className="mce-radio__indicator" />
                <span className="mce-radio__label">{m.dsLocalCiencia}</span>
              </label>
            ))}
          </div>

          <div className="mce-column">
            {secondColumn.map((m: any) => (
              <label
                key={m.cdSeqCienciaEvento}
                className={classNames("mce-radio", {
                  "mce-radio--selected":
                    selectedOption === m.cdSeqCienciaEvento.toString(),
                })}
              >
                <input
                  type="radio"
                  name="cienciaEvento"
                  value={m.cdSeqCienciaEvento.toString()}
                  checked={selectedOption === m.cdSeqCienciaEvento.toString()}
                  onChange={handleRadioChange}
                />
                <span className="mce-radio__indicator" />
                <span className="mce-radio__label">{m.dsLocalCiencia}</span>
              </label>
            ))}

            <label
              className={classNames("mce-radio", {
                "mce-radio--selected": selectedOption === "-1",
              })}
            >
              <input
                type="radio"
                name="cienciaEvento"
                value="-1"
                checked={selectedOption === "-1"}
                onChange={handleRadioChange}
              />
              <span className="mce-radio__indicator" />
              <span className="mce-radio__label">Outros</span>
            </label>

            <If condition={showOutrosInput}>
              <div className="mce-outros-input">
                <input
                  type="text"
                  placeholder="Descreva como conheceu o evento..."
                  value={cienciaEventoOutros || ""}
                  onChange={handleTextChange}
                  className="mce-outros-input__field"
                />
              </div>
            </If>
          </div>
        </div>
      </div>

      <div className="mce-footer-section">
        <div className="mce-notification">
          <Checkbox
            checked={checked === true}
            onChange={() => setChecked(!checked)}
          />
          <span className="mce-notification__label">
            Desejo receber por e-mail atualizações sobre esse evento.
          </span>
        </div>

        <div className="mce-captcha">
          <If condition={showCaptcha}>
            <ReCAPTCHA
              ref={captchaRef}
              size="normal"
              sitekey={Environment.getRecaptchaSiteKey()}
            />
          </If>
        </div>
      </div>
    </div>
  );
}
